// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const orbeetle_gmax: PokeData = {
  "id": 10213,
  "name": "orbeetle-gmax",
  "height": 140,
  "weight": 10000,
  "base_experience": 253,
  "types": [
    PokeType.BUG,
    PokeType.PSYCHIC
  ],
  "api_moves": [],
  "moves": [
    "signal-spam",
    "healing-wish",
    "zen-headbutt",
    "psychic",
    "infest",
    "heal-order",
    "pounce",
    "psy-ball",
    "pin-rush",
    "bug-buzz",
    "future-sight",
    "psychic-fangs",
    "bug-bite"
  ],
  "evolution_chain": {
    "id": 435,
    "item": null,
    "species": [
      {
        "name": "blipbug",
        "order": 824,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "dottler",
        "order": 825,
        "types": [
          PokeType.BUG,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 824,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 10,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "orbeetle",
        "order": 826,
        "types": [
          PokeType.BUG,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 825,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 136,
    "speed": 140,
    "ability_power": 124
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": true,
  "regional_variant": null
} as const;
